import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const TexMexModal = ({ isOpen, onClose, item, category, onAddToCart }) => {
  const [selectedSize, setSelectedSize] = useState('');

  if (!isOpen || !item) return null;

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert('Veuillez choisir une taille (8 ou 12 pièces)');
      return;
    }

    const price = selectedSize === '8' ? 8.90 : 11.90;
    
    const cartItem = {
      id: `${category.name}-${item.name}-${selectedSize}pieces-${Date.now()}`,
      name: `Tex Mex – ${item.name} - ${selectedSize} pièces`,
      price: `${price.toFixed(2)} €`,
      description: `${selectedSize} pièces`,
      category: category.name,
      quantity: 1,
      options: {
        size: selectedSize,
        optionsText: `${selectedSize} pièces`
      }
    };

    onAddToCart(cartItem);
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setSelectedSize('');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-testid="texmex-modal">
      <div className="bg-white rounded-lg max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-bold text-gray-800" data-testid="texmex-modal-title">
            {item.name}
          </h2>
          <button onClick={handleClose} className="text-gray-500 hover:text-gray-700" data-testid="texmex-modal-close-btn">
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <h3 className="font-semibold text-gray-900" data-testid="texmex-item-name">{item.name}</h3>
            {item.description && (
              <p className="text-sm text-gray-600 mt-1" data-testid="texmex-item-desc">{item.description}</p>
            )}
          </div>

          <div>
            <h4 className="font-medium text-gray-900 mb-3" data-testid="texmex-size-title">
              Choisissez le nombre de pièces *
            </h4>
            <div className="space-y-2">
              {/* 8 pièces */}
              <button
                onClick={() => setSelectedSize('8')}
                className={`w-full p-3 text-left border rounded-lg transition-colors ${
                  selectedSize === '8'
                    ? 'border-[#D47A2A] bg-[#D47A2A] text-white'
                    : 'border-gray-300 hover:border-[#D47A2A] text-gray-900'
                }`}
                data-testid="texmex-size-8"
              >
                <div className="flex justify-between items-center">
                  <span>8 pièces</span>
                  <span className="font-bold">8,90€</span>
                </div>
              </button>

              {/* 12 pièces */}
              <button
                onClick={() => setSelectedSize('12')}
                className={`w-full p-3 text-left border rounded-lg transition-colors ${
                  selectedSize === '12'
                    ? 'border-[#D47A2A] bg-[#D47A2A] text-white'
                    : 'border-gray-300 hover:border-[#D47A2A] text-gray-900'
                }`}
                data-testid="texmex-size-12"
              >
                <div className="flex justify-between items-center">
                  <span>12 pièces</span>
                  <span className="font-bold">11,90€</span>
                </div>
              </button>
            </div>
            {!selectedSize && (
              <p className="text-red-600 text-sm mt-2" data-testid="texmex-size-error">Veuillez sélectionner une taille</p>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="border-t p-4">
          <div className="flex space-x-3">
            <Button
              variant="outline"
              onClick={handleClose}
              className="flex-1 border-gray-400 text-gray-900 bg-white hover:bg-gray-100 hover:text-gray-900"
              data-testid="texmex-modal-cancel-btn"
            >
              Annuler
            </Button>
            <Button
              onClick={handleAddToCart}
              disabled={!selectedSize}
              className="flex-1 bg-[#D47A2A] hover:bg-[#B8661F] text-white disabled:opacity-50"
              data-testid="texmex-modal-add-btn"
            >
              Ajouter au panier
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TexMexModal;